import { GridBaseModel } from "../common/GridBaseModel";
import { HubEvents } from "../common/HubEventsEnum";

export class StakeholderUploadFileHub extends GridBaseModel {
  hubName: string = "stakeholder-upload-file";

  constructor() {
    super("stakeholder-upload-file");
  }

  onLoadData = callback => this.registerIncomingEvent(HubEvents.ON_STAKEHOLDER_UPLOAD_FILE_GRID_DATA, callback);

  invokeLoadData = async (organisationId: number) => {
    if (!this.isConnectionStarted) return;
    await this.connection.invoke(HubEvents.INVOKE_LOAD_STAKEHOLDER_UPLOAD_FILE_GRID_DATA, {
      organisationId: organisationId
    });
  };
}

const instance = new StakeholderUploadFileHub();
export default instance;
